var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { SystemCategoriesClient, SystemCategoryModel, GetSystemCategoryListPaginatedQuery, PaginatedEnumerableOfSystemCategoryModel, CreateSystemCategoryCommand, UpdateSystemCategoryCommand, SortDescription, SortDirection } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import Sorter from "@/common/utils/sorter";
import { HttpHelper } from "@/app/utils/http-helper";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const systemCategoriesClient = new SystemCategoriesClient(window.apiUrl);
let CompanySystemCategoriesVue = class CompanySystemCategoriesVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.working = false;
        this.editingModel = false;
        this.searchAttempted = false;
        // components
        this.sorter = new Sorter(new SortDescription({
            fieldName: "Name",
            direction: SortDirection.Ascending
        }));
        // models
        this.model = new SystemCategoryModel();
        this.query = new GetSystemCategoryListPaginatedQuery({
            pageNo: 1,
            pageSize: 100,
            includeDeleted: false,
            companyId: this.companyId,
            sort: this.sorter.currentSort
        });
        this.data = new PaginatedEnumerableOfSystemCategoryModel();
    }
    created() {
        this.search();
    }
    ;
    // get
    search() {
        if (!this.canSearch)
            return;
        if (this.working)
            return;
        if (!this.query)
            return;
        this.working = true;
        systemCategoriesClient
            .getListPaginated(this.query)
            .then(response => {
            this.data = new PaginatedEnumerableOfSystemCategoryModel();
            if (!response)
                return;
            this.data = response;
            this.query.pageNo = this.data.displayedPage;
            this.query.pageSize = this.data.pageSize;
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.searchAttempted = true;
        });
    }
    ;
    onSortChanged() {
        this.query.sort = this.sorter.currentSort;
        this.search();
    }
    ;
    // set
    add() {
        this.model = new SystemCategoryModel();
        this.model.companyId = this.query.companyId || 0;
        this.resetForm();
        this.editingModel = true;
    }
    ;
    edit(model) {
        this.model = new SystemCategoryModel(model);
        this.editingModel = true;
        this.setValues({
            name: this.model.name
        });
    }
    ;
    save(model) {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            let promise = () => {
                return !model.id
                    ? systemCategoriesClient.add(new CreateSystemCategoryCommand({ requestModel: model }))
                    : systemCategoriesClient.update(model.id, new UpdateSystemCategoryCommand({ requestModel: model }));
            };
            promise().then(response => {
                Notifier.onOk();
                model.modelId = response;
                this.editingModel = false;
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
                this.search();
            });
        }, () => {
            Notifier.onError("Please check that you have correctly entered a category name.");
        });
        handleSubmitAction();
    }
    ;
    archive(model) {
        if (this.working)
            return;
        this.$confirmModal.show("Are you sure that you want to archive this system category?", { title: "Please confirm" })
            .then((value) => {
            if (!value)
                return;
            this.working = true;
            systemCategoriesClient
                .delete(model.id)
                .then(() => {
                model.whenDeleted = new Date();
                Notifier.onOk();
            })
                .catch((ex) => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        });
    }
    ;
    restore(model) {
        if (this.working)
            return;
        this.working = true;
        systemCategoriesClient
            .restore(model.id)
            .then(() => {
            model.whenDeleted = undefined;
            Notifier.onOk();
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    cancel() {
        this.resetForm();
        this.model = new SystemCategoryModel();
        this.editingModel = false;
    }
    ;
    // computed
    get canSearch() {
        return this.companyId ? true : false;
    }
    ;
    get noData() {
        return this.searchAttempted && (!this.data || !this.data.records || !this.data.records.length);
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", Number)
], CompanySystemCategoriesVue.prototype, "companyId", void 0);
__decorate([
    Watch("query.pageNo"),
    Watch("query.includeDeleted"),
    Watch("query.companyId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySystemCategoriesVue.prototype, "search", null);
__decorate([
    Watch("sorter.currentSort"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CompanySystemCategoriesVue.prototype, "onSortChanged", null);
CompanySystemCategoriesVue = __decorate([
    Component({
        name: "CompanySystemCategoriesVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds, setValues, resetForm } = useForm({
                validationSchema: yup.object({
                    name: yup.string().trim().required(),
                }),
            });
            const nameVal = defineInputBinds('name');
            return {
                errors,
                handleSubmit,
                setValues,
                resetForm,
                nameVal
            };
        }
    })
], CompanySystemCategoriesVue);
export default CompanySystemCategoriesVue;
